<template>
  <el-row v-if="single">
    <el-col :md="8" :xs="24">
      <risk-type :height="height" ref="type" :show-title="single"
      ></risk-type>
    </el-col>
    <el-col :md="8" :xs="24">
      <risk-nation :height="height"  ref="nation" :show-title="single"
    ></risk-nation>
    </el-col>
    <el-col :md="8" :xs="24">
      <risk-line :height="height"  ref="line" :show-title="single"
      ></risk-line>
    </el-col>

  </el-row>
</template>

<script>
import RiskNation from './risk_nation.vue'
import RiskType from './risk_type.vue'
import RiskLine from './risk_line.vue'
export default {
  name: 'pbrChartRiskIndex',
  props: {
    single: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      require: true
    }
  },
  data(){
    return {
      height: 200
    }
  },
  components: {
    RiskNation,
    RiskType,
    RiskLine
  },
  methods: {
    riskTradeChartClick (name) {
      // this.$emit('update:emphasesCategory', 'risk')
    },
    riskTypeChartClick (name) {
      // this.$emit('update:emphasesCategory', 'risk')
    },
    riskDateChartClick (name) {
      // this.$emit('update:emphasesCategory', 'risk')
    },
    resize () {
      this.$refs.line && this.$refs.line.resize()
      this.$refs.nation && this.$refs.nation.resize()
      this.$refs.type && this.$refs.type.resize()
    }
  },
  mounted () {
    window.addEventListener('resize', this.resize)
    let bodyStyle = window.getComputedStyle(document.body)
    let computedStyle = window.getComputedStyle(document.querySelector('.pbr-index-charts'))
    this.height = Math.min(parseFloat(computedStyle.height), parseFloat(computedStyle.width))
    if (parseInt(bodyStyle.height) < 992) {
      this.height = parseFloat(computedStyle.height) / 3 - 20
    }
  },
}
</script>

<style lang="scss" scoped>
</style>
